<template>
  <div class="main">
    <v-overlay v-if="isLoading" dark opacity="1" color="white">
      <v-progress-circular :value="20" color="green" indeterminate></v-progress-circular>
    </v-overlay>
    <div class="bar" style="font-family: 'Prompt' !important">
      <vue-file-toolbar-menu :content="menu1" class="bar" style="padding-top: 20px" />
      <vue-file-toolbar-menu :content="menu2" class="bar" />
    </div>
    <vue-document-editor v-if="isTimeOuted && content" class="editor font-size" ref="editor" id="editor"
      :content.sync="content" :zoom="zoom" :page_format_mm="pageFormat" :page_margins="pageMargins" :display="display" />
    <div>
      <v-dialog v-model="isDialogSaveNew" max-width="500" scrollable>
        <v-form @submit.prevent="onDialogSaveNewAgree()" ref="form" :lazy-validation="true">
          <v-card style="font-family: 'Prompt' !important">
            <v-card-title style="font-family: 'Prompt' !important">
              <h2>{{ $t('customer.save_document') }}</h2>
            </v-card-title>
            <!-- <v-divider></v-divider> -->
            <v-card-text class="py-0">
              <span>{{ $t('validate.please_input_document_name') }}</span>
              <v-text-field v-model="tempTitle" flat background-color="grey lighten-4" solo :label="$t('project.document_template_title')"
                :rules="[rules.required]"></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="error" @click="isDialogSaveNew = false">{{ $t('cancel') }}</v-btn>
              <v-btn class="success" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="isDialogAddData" max-width="800" class="bar" style="pointer-events: none;" persistent scrollable>
        <v-card style="font-family: 'Prompt' !important">
          <v-card-title style="font-family: 'Prompt' !important">
            <div class="flex justify-between">
              {{ $t('data') }}
              <v-spacer></v-spacer>
              <v-icon @click="isDialogAddData = false">mdi-close</v-icon>
            </div>
            <v-tabs v-model="tab">
              <v-tab value="all">{{ $t('all') }}</v-tab>
              <v-tab value="customer">{{ $t('customer.customer_information') }}</v-tab>
              <v-tab value="contract">{{ $t('contract.contract_information') }}</v-tab>
              <v-tab value="bill">{{ $t('bill.bill_information') }}</v-tab>
              <v-tab value="contractSuspend">{{ $t('suspend.contract_suspend_information') }}</v-tab>
              <v-tab value="areaInterest">{{ $t('customer.interested_in_business') }}</v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text>

            <v-tabs-items v-model="tab" class="pt-2">
              <v-tab-item key="all">
                <v-text-field v-model="searchData" flat background-color="grey lighten-4" solo :label="$t('search')"
                  hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="dataTable.data"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
              <v-tab-item key="customer">
                <v-text-field v-model="searchCustomerInputData" flat background-color="grey lighten-4" solo :label="$t('search')"
                  hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="customerInputData"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchCustomerInputData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
              <v-tab-item key="contract">
                <v-text-field v-model="searchContractInputData" flat background-color="grey lighten-4" solo :label="$t('search')"
                  hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="contractInputData"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchContractInputData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
              <v-tab-item key="bill">
                <v-text-field v-model="searchBillInputData" flat background-color="grey lighten-4" solo :label="$t('search')"
                  hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="billInputData"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchBillInputData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
              <v-tab-item key="contractSuspend">
                <v-text-field v-model="searchContractSuspendInputData" flat background-color="grey lighten-4" solo
                  :label="$t('search')" hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="contractSuspendInputData"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchContractSuspendInputData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
              <v-tab-item key="areaInterest">
                <v-text-field v-model="searchAreaInterestInputData" flat background-color="grey lighten-4" solo
                  :label="$t('search')" hide-details></v-text-field>
                <v-data-table
                  :headers="dataTable.headers"
                  :items="areaInterestInputData"
                  :items-per-page="10"
                  class="elevation-1 mt-5"
                  @click:row="addText"
                  :search="searchAreaInterestInputData"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')">
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isDialogContractData" max-width="1000" class="bar" style="pointer-events: none;" scrollable>
        <v-card style="font-family: 'Prompt' !important">
          <v-card-title style="font-family: 'Prompt' !important">
            {{ $t('project.setting_information') }}
            <v-spacer></v-spacer>
            <v-icon @click="isDialogContractData = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-card v-for="aera in billingSettingAreas" :key="aera.objectId">
              <v-card-title>
                {{ aera.name }}
                <v-icon @click="copyText(aera.name)">mdi-content-copy</v-icon>
              </v-card-title>
              <v-card-text v-for="billingSetting in hashBillingSettings[aera.objectId]" :key="billingSetting.objectId">
                <h4>
                  {{ billingSetting.accountingProduct.name }}
                  <v-icon @click="copyText(billingSetting.accountingProduct.name)">mdi-content-copy</v-icon>
                </h4>
                <div class="ps-5">
                  <v-text-field
                    :value="`${$t('area.space')} ${aera.name} ${billingSetting.accountingProduct.name} ${$helper.toCurrency(billingSetting.cost)} ${pricePerType(billingSetting)} ${$helper.numberToText(billingSetting.cost)} ${pricePerType(billingSetting)}`"
                    class="my-3" flat background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')"
                    hide-details readonly append-icon="mdi-content-copy"
                    @click:append="copyText($helper.toCurrency(billingSetting.cost))"></v-text-field>
                  <v-row>
                    <v-col cols="6" class="pt-0">
                      <!-- <v-text-field
                          :value="billingSetting.cost"
                          class="my-3"
                          flat
                          background-color="grey lighten-4"
                          solo
                          placeholder="จำนวนเงิน (ตัวหนังสือ)"
                          hide-details
                          readonly
                          append-icon="mdi-content-copy"
                          @click:append="copyText(billingSetting.cost)"
                        ></v-text-field>-->
                      <v-text-field :value="$helper.toCurrency(billingSetting.cost)" class="my-3" flat
                        background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')" hide-details readonly
                        append-icon="mdi-content-copy"
                        @click:append="copyText($helper.toCurrency(billingSetting.cost))"></v-text-field>
                      <!-- <v-text-field
                          :value="$helper.thaiBaht(billingSetting.cost)"
                          class="my-3"
                          flat
                          background-color="grey lighten-4"
                          solo
                          placeholder="จำนวนเงิน (ตัวหนังสือ)"
                          hide-details
                          readonly
                          append-icon="mdi-content-copy"
                          @click:append="copyText($helper.thaiBaht(billingSetting.cost))"
                        ></v-text-field>-->
                      <v-text-field :value="$helper.numberToText(billingSetting.cost)" class="my-3" flat
                        background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')" hide-details readonly
                        append-icon="mdi-content-copy"
                        @click:append="copyText($helper.numberToText(billingSetting.cost))"></v-text-field>
                    </v-col>

                    <v-col cols="6" class="pt-0">
                      <!-- <v-text-field
                          :value="`${billingSetting.cost} ${pricePerType(billingSetting)}`"
                          class="my-3"
                          flat
                          background-color="grey lighten-4"
                          solo
                          placeholder="จำนวนเงิน (ตัวหนังสือ)"
                          hide-details
                          readonly
                          append-icon="mdi-content-copy"
                          @click:append="copyText(`${billingSetting.cost} ${pricePerType(billingSetting)}`)"
                        ></v-text-field>-->
                      <v-text-field :value="`${$helper.toCurrency(billingSetting.cost)} ${pricePerType(billingSetting)}`"
                        class="my-3" flat background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')"
                        hide-details readonly append-icon="mdi-content-copy"
                        @click:append="copyText(`${$helper.toCurrency(billingSetting.cost)} ${pricePerType(billingSetting)}`)"></v-text-field>
                      <!-- <v-text-field
                          :value="`${$helper.thaiBaht(billingSetting.cost)} ${pricePerType(billingSetting,'currency')}`"
                          class="my-3"
                          flat
                          background-color="grey lighten-4"
                          solo
                          placeholder="จำนวนเงิน (ตัวหนังสือ)"
                          hide-details
                          readonly
                          append-icon="mdi-content-copy"
                          @click:append="copyText(`${$helper.thaiBaht(billingSetting.cost)} ${pricePerType(billingSetting,'currency')}`)"
                        ></v-text-field>-->
                      <v-text-field
                        :value="`${$helper.numberToText(billingSetting.cost)} ${pricePerType(billingSetting)}`"
                        class="my-3" flat background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')"
                        hide-details readonly append-icon="mdi-content-copy"
                        @click:append="copyText(`${$helper.numberToText(billingSetting.cost)} ${pricePerType(billingSetting)}`)"></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isDialogConvertNumber" max-width="800" class="bar" style="pointer-events: none;">
        <v-card style="font-family: 'Prompt' !important">
          <v-card-title style="font-family: 'Prompt' !important">
            {{ $t('payment.convert_number') }}
            <v-spacer></v-spacer>
            <v-icon @click="convertNumber = null; isDialogConvertNumber = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-currency-field v-model="convertNumber" ref="convertNumber" class="my-3" flat
              background-color="grey lighten-4 input-disable-appearance" solo :placeholder="$t('payment.input_number')" hide-details
              prepend-icon="mdi-counter"
              @input="(value) => (convertNumber = parseFloat(convertNumber))" />
            <v-text-field :value="$helper.thaiBaht(convertNumber)" ref="textCurrency" class="my-3" flat
              background-color="grey lighten-4" solo :placeholder="$t('payment.money_in_text')" hide-details readonly
              prepend-icon="mdi-cash-multiple" append-icon="mdi-content-copy"
              @click:append="copyText($helper.thaiBaht(convertNumber))"></v-text-field>
            <v-text-field :value="$helper.numberToText(convertNumber)" ref="textNumber" class="my-3" flat
              background-color="grey lighten-4" solo :placeholder="$t('payment.number_in_text')" hide-details readonly
              prepend-icon="mdi-counter" append-icon="mdi-content-copy"
              @click:append="copyText($helper.numberToText(convertNumber))"></v-text-field>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isPaperSettingDialog" max-width="600" class="bar" style="pointer-events: none;" persistent>
        <v-card style="font-family: 'Prompt' !important">
          <v-card-title style="font-family: 'Prompt' !important">
            {{ $t('project.setting_font_size') }}
            <v-spacer></v-spacer>
            <v-icon @click="isPaperSettingDialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-row class="mt-4">
              <v-col cols="6" class="d-flex justify-center align-center">{{ $t('project.font_size') }}</v-col>
              <v-col cols="6">
                <v-select v-model="pageFontSize" :items="fontSizeList" item-text="text" item-value="value" flat
                  background-color="grey lighten-4" solo :label="$t('size')" hide-details :no-data-text="$t('noinfo')"/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-6">
            <v-spacer></v-spacer>
            <!-- <v-btn
              color="success"
              type="submit"
              elevation="0"
              @click="isPaperSettingDialog = false"
            >
              <v-icon left>mdi-content-save</v-icon> บันทึก
            </v-btn>-->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isAddTableDialog" max-width="350" class="bar" style="pointer-events: none;" persistent>
        <v-form @submit.prevent="onAddTable()" ref="formTable">
          <v-card style="font-family: 'Prompt' !important">
            <v-card-title style="font-family: 'Prompt' !important">
              {{ $t('add_table') }}
              <v-spacer></v-spacer>
              <v-icon @click="isAddTableDialog = false">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
              <span>{{ $t('size') }}</span>
              <v-currency-field v-model="formTable.width" class="input-disable-appearance" flat
                background-color="grey lighten-4" solo :label="$t('size')"
                :rules="[rules.required, rules.maxPercent, rules.minPercent]" suffix="%"/>

              <span>{{ $t('column') }}</span>
              <v-currency-field v-model="formTable.col" class="input-disable-appearance" flat
                background-color="grey lighten-4" solo :label="$t('column')"
                :rules="[rules.required]" />

              <span>{{ $t('row') }}</span>
              <v-currency-field v-model="formTable.row" class="input-disable-appearance" flat
                background-color="grey lighten-4" solo :label="$t('row')" :rules="[rules.required]" />

              <span>{{ $t('position') }}</span>
              <div class="ps-3">
                <v-radio-group v-model="formTable.position">
                  <v-radio :label="$t('position_left')" value="start"></v-radio>
                  <v-radio :label="$t('position_center')" value="center"></v-radio>
                  <v-radio :label="$t('position_right')" value="end"></v-radio>
                </v-radio-group>
              </div>
            </v-card-text>
            <v-card-actions class="px-6">
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit" elevation="0">{{ $t('action_type.add') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="isAddExampleImage" fullscreen class="bar" persistent scrollable>
        <v-card class="card-add-image">
          <v-card-title class="d-flex justify-center py-0" style="background-color: white; z-index: 3;">
            <div style="width: 400px; scale: .8">
              <v-slider v-model="imageWidth" :max="sliderMaxWidth" :min="1" label="Width" class="align-center"
                color="blue" hide-details @input="onChageSize('width')" :disabled="isAutoImageWidth">
                <template v-slot:append>
                  <v-currency-field v-model="imageWidth" outlined dense class="mt-0 pt-0" style="width: 100px"
                    suffix="px" hide-details :disabled="isAutoImageWidth" />
                </template>
              </v-slider>
              <div class="auto-width">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-checkbox v-model="isAutoImageWidth" :label="`Fixed width`" class="mt-0"
                        hide-details></v-checkbox>
                    </span>
                  </template>
                  <span>{{ $t('project.real_image_width') }}</span>
                </v-tooltip>
              </div>
              <div class="link-variant">
                <v-icon @click="onLockAspect" :color="isLockAspect ? 'success' : ''">mdi-link-variant</v-icon>
              </div>
            </div>
          </v-card-title>
          <v-card-title class="d-flex justify-center py-0"
            style="box-shadow: 0px 2px 2px rgb(198, 198, 198); z-index: 2; background-color: white;">
            <div style="width: 400px; scale: .8">
              <v-slider v-model="imageHeight" :max="sliderMaxHeight" :min="1" label="Height" class="align-center"
                color="blue" hide-details @input="onChageSize('height')" :disabled="isAutoImageHeight">
                <template v-slot:append>
                  <v-currency-field v-model="imageHeight" outlined dense class="mt-0 pt-0" style="width: 100px"
                    suffix="px" hide-details :disabled="isAutoImageHeight" />
                </template>
              </v-slider>
              <div class="auto-height">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-checkbox v-model="isAutoImageHeight" :label="`Fixed height`" class="mt-0"
                        hide-details></v-checkbox>
                    </span>
                  </template>
                  <span>{{ $t('project.real_image_height') }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-card-title>
          <v-card-text class="px-4 py-15">
            <div class="d-flex justify-center">
              <img :src="exampleImgSrc" alt="" id="image-example"
                :style="`width: ${imageWidth && !isAutoImageWidth ? imageWidth + 'px' : 'auto'}; height: ${imageHeight && !isAutoImageHeight ? imageHeight + 'px' : 'auto'};`">
            </div>
          </v-card-text>
          <v-card-actions style="box-shadow: 0px -2px 2px rgb(198, 198, 198); z-index: 2; background-color: white;">
            <v-spacer></v-spacer>
            <v-btn color="success" type="submit" elevation="0" @click="uploadExampleImage()">
              <v-icon left>mdi-upload</v-icon> {{ $t('insert_image') }}
            </v-btn>
            <v-btn color="error" elevation="0" @click="isAddExampleImage = false">{{ $t('cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <UploadImage v-model="isUploadImageDialog" @onSuccess="onUploadImageSuccess" />
      <ConfirmDialog v-model="isCloseDialog" :title="$t('validate.you_want_to_close_this_window')" :textBtnOk="$t('close_window')"
        :textBtnCancel="$t('cancel')" type="error" @onOk="$emit('onClose', true)" @onCancel="isCloseDialog = false" />
      <v-snackbar v-model="isCopySuccess" color="success" top timeout="1000">
        <v-icon left size="18">mdi-content-copy</v-icon>Copy {{ $t('success') }}
      </v-snackbar>
      <v-snackbar v-model="isSuccess" color="success" top>
        <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
      </v-snackbar>
    </div>
    <div id="demo-templete"></div>
  </div>
</template>

<script>
import VueFileToolbarMenu from "vue-file-toolbar-menu";
import VueDocumentEditor from "vue-document-editor";
import ConfirmDialog from "@/components/ConfirmDialog.component.vue";
import UploadImage from "@/components/UploadImage.component.vue";
import { mapState } from "vuex";
export default {
  components: {
    VueDocumentEditor,
    VueFileToolbarMenu,
    ConfirmDialog,
    UploadImage
  },
  props: {
    title: String,
    layout: Array,
    paperSetting: Object,
    type: String,
    templateObjectData: Object,
    // billingSettings: Array,
    projectId: String
  },
  data() {
    return {
      // This is where the pages content is stored and synced
      isLoading: false,
      content: [""],
      zoom: 1,
      zoom_min: 0.1,
      zoom_max: 5.0,
      pageFormat: [210, 297],
      pageMargins: "10mm 15mm",
      pageFontSize: null,
      display: "vertical", // ["grid", "vertical", "horizontal"]
      mounted: false, // will be true after this component is mounted
      undo_count: -1, // contains the number of times user can undo (= current position in content_history)
      content_history: [], // contains the content states for undo/redo operations,
      fontSize: 16,
      isDialogSaveNew: false,
      tempTitle: "",
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        maxPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        minPercent: v => v > 0 || this.$t('validate.please_min_cost', { currencySign: '' })
      },
      isDialogAddData: false,
      searchData: "",
      searchCustomerInputData: "",
      searchContractInputData: "",
      searchBillInputData: "",
      searchContractSuspendInputData: "",
      searchAreaInterestInputData: "",
      searchContractCheckoutInputData: "",
      tempRange: null,
      tempContent: null,
      isCloseDialog: false,
      isTimeOuted: false,
      isDialogConvertNumber: false,
      convertNumber: null,
      isCopySuccess: false,
      // hashBillingSettings: {},
      billingSettingAreas: [],
      isDialogContractData: false,
      isUploadImageDialog: false,
      isPaperSettingDialog: false,
      isSuccess: false,
      isAddTableDialog: false,
      formTable: {
        width: 100,
        col: null,
        row: null,
        position: "center"
      },
      isAddExampleImage: false,
      exampleImgSrc: null,
      imageWidth: 0,
      imageHeight: 0,
      tempImageWidth: 0,
      tempImageHeight: 0,
      sliderMaxWidth: 0,
      sliderMaxHeight: 0,
      isLockAspect: false,
      isAutoImageWidth: false,
      isAutoImageHeight: false,
      tab: "all",
      customerInputData: [
        {
          name: this.$t('customer.prefix_customer'),
          value: "cusTitle"
        },
        {
          name: this.$t('market.customer_name_and_company_name_not_space'),
          value: "cusFName"
        },
        {
          name: this.$t('customer.postfix_customer'),
          value: "cusLName"
        },
        {
          name: this.$t('customer.customer_type'),
          value: "cusType"
        },
        {
          name: this.$t('customer.age_customer'),
          value: "cusAge"
        },
        {
          name: this.$t('account.profile_image'),
          value: "cusProfileImg"
        },
        {
          name: this.$t('account.citizen_card_image'),
          value: "cusCitizenCardImg"
        },
        {
          name: this.$t('account.citizen_id_card'),
          value: "cusCitizenId"
        },
        {
          name: this.$t('account.issue_date_card'),
          value: "cusCardIssueDate"
        },
        {
          name: this.$t('account.expire_date_card_another_form'),
          value: "cusCardExpDate"
        },
        {
          name: this.$t('customer.address_customer'),
          value: "cusAddress"
        },
        {
          name: this.$t('customer.phone_customer'),
          value: "cusTel"
        },
        {
          name: this.$t('customer.bank_account_customer'),
          value: "cusBanks"
        },
        {
          name: this.$t('customer.main_contact_name'),
          value: "cusEName"
        },
        {
          name: this.$t('customer.main_contact_phone'),
          value: "cusETel"
        },
        {
          name: this.$t('customer.main_contact_relation'),
          value: "cusERelation"
        },
        {
          name: this.$t('customer.main_contact_email'),
          value: "cusEEmail"
        },
        {
          name: "Facebook",
          value: "cusFacebook"
        },
        {
          name: "Line",
          value: "cusLine"
        },
        {
          name: "Instagram",
          value: "cusInstagram"
        },
        {
          name: "Youtube",
          value: "cusYoutube"
        },
        {
          name: "Tiktok",
          value: "cusTiktok"
        },
      ],
      contractInputData: [
        {
          name: this.$t('contract.contract_number_only'),
          value: "conId"
        },
        {
          name: this.$t('area.shop_name'),
          value: "conBusinessName"
        },
        {
          name: this.$t('current_date'),
          value: "fullDate"
        },
        {
          name: this.$t('project.project_name_only'),
          value: "proName"
        },
        {
          name: this.$t('project.market_name_only'),
          value: "marName"
        },
        // {
        //   name: "ระยะเวลา(ตัวเลข)",
        //   value: "conLenNum"
        // },
        // {
        //   name: "ระยะเวลา(ตัวหนังสือ)",
        //   value: "conLenNumText"
        // },
        {
          name: this.$t('contract.contract_duration_day_number'),
          value: "conLenDNum"
        },
        {
          name: this.$t('contract.contract_duration_day_text'),
          value: "conLenDNumText"
        },
        {
          name: this.$t('contract.contract_duration_year'),
          value: "conLenYNum"
        },
        {
          name: this.$t('contract.start_date'),
          value: "conSFullDate"
        },
        {
          name: this.$t('contract.end_date'),
          value: "conEFullDate"
        },
        {
          name: this.$t('area.area_name'),
          value: "conAreas"
        },
        {
          name: this.$t('area.number_of_stall'),
          value: "conAreaLen"
        },
        {
          name: this.$t('area.number_of_stall_text'),
          value: "conAreaLenText"
        },
        {
          name: this.$t('area.area_size_square_meter_space'),
          value: "conAreaSize"
        },
        {
          name: this.$t('area.area_size_square_meter_space_text'),
          value: "conAreaSizeText"
        },
        {
          name: this.$t('product.title'),
          value: "conProducts"
        },
        {
          name: this.$t('product.product_type'),
          value: "conCategory"
        },
        {
          name: this.$t('contract.contract_address'),
          value: "conAddress"
        },
        {
          name: this.$t('customer.recorder'),
          value: "createdBy"
        },
      ],
      billInputData: [],
      contractSuspendInputData: [
        {
          name: this.$t('area.area_name'),
          value: "conAreas"
        },
        {
          name: this.$t('area.number_of_stall'),
          value: "conAreaLen"
        },
        {
          name: this.$t('area.warning_type'),
          value: "spdType"
        },
        {
          name: this.$t('area.event_date'),
          value: "spdIssueDate"
        },
        {
          name: this.$t('suspend.start_suspend_stall_date'),
          value: "spdStartDate"
        },
        {
          name: this.$t('suspend.end_suspend_stall_date'),
          value: "spdEndDate"
        },
        {
          name: this.$t('suspend.suspend_stall_or_suspend_sale'),
          value: "spdSuspend"
        },
        {
          name: this.$t('area.event_detail'),
          value: "spdDetail"
        },
        {
          name: this.$t('project.offense_rule'),
          value: "spdPenaltyDetail"
        },
        {
          name: this.$t('detail'),
          value: "note"
        }
      ],
      areaInterestInputData: [
        {
          name: this.$t('customer.trader_type_old_new'),
          value: "aiCusNew"
        },
        {
          name: this.$t('customer.customer_type'),
          value: "cusType"
        },
        {
          name: this.$t('customer.prefix_customer'),
          value: "cusTitle"
        },
        {
          name: this.$t('market.customer_name_and_company_name_not_space'),
          value: "cusFName"
        },
        {
          name: this.$t('customer.postfix_customer'),
          value: "cusLName"
        },
        {
          name: this.$t('account.citizen_id_card'),
          value: "cusCitizenId"
        },
        {
          name: this.$t('customer.phone_customer'),
          value: "cusTel"
        },
        {
          name: this.$t('contract.start_date'),
          value: "conSFullDate"
        },
        {
          name: this.$t('contract.end_date'),
          value: "conEFullDate"
        },
        {
          name: this.$t('area.stall_type'),
          value: "conType"
        },
        {
          name: this.$t('area.interested_stall'),
          value: "aiAreasQty"
        },
        {
          name: this.$t('area.area_name'),
          value: "conAreas"
        },
        {
          name: this.$t('product.title'),
          value: "conProducts"
        },
        {
          name: this.$t('product.product_type'),
          value: "conCategory"
        },
        {
          name: this.$t('note'),
          value: "note"
        }
      ],
      contractCheckoutInputData: [
        {
          name: this.$t('contract.contract_number_only'),
          value: "conId"
        },
        {
          name: this.$t('area.checkout_date'),
          value: "outDate"
        },
        {
          name: this.$t('customer.prefix_customer'),
          value: "cusTitle"
        },
        {
          name: this.$t('market.customer_name_and_company_name_not_space'),
          value: "cusFName"
        },
        {
          name: this.$t('customer.postfix_customer'),
          value: "cusLName"
        },
        {
          name: this.$t('area.shop_name'),
          value: "conBusinessName"
        },
        {
          name: this.$t('contract.contract_stall_name'),
          value: "conAreas"
        },
        {
          name: this.$t('area.checkout_stall_name'),
          value: "outAreas"
        },
        {
          name: this.$t('payment.total'),
          value: "outTotal"
        },
        {
          name: this.$t('payment.payment_or_refund_date'),
          value: "outPayDate"
        },
        {
          name: this.$t('payment.payment_received_by'),
          value: "outReceivedBy"
        },
        {
          name: this.$t('note'),
          value: "note"
        }
      ],
      dataTable: {
        headers: [
          {
            text: this.$t('data'),
            align: "center",
            value: "name",
            width: "50%"
          },
          {
            text: "value",
            align: "center",
            value: "value",
            width: "50%"
          }
        ],
        data: []
      }
    };
  },
  async created() {
    if (this.title) this.tempTitle = this.title;
    if (this.layout) this.content = this.layout;
    if (this.paperSetting) {
      let setting = this.paperSetting || {};
      if (setting.pageFormat) this.pageFormat = setting.pageFormat;
      if (setting.pageMargins) this.pageMargins = setting.pageMargins;
      this.pageFontSize = setting.pageFontSize || "16px";
    }

    // if(this.billingSettings && this.billingSettings.length){
    //   for(let billingSetting of this.billingSettings){
    //     if(!this.hashBillingSettings[billingSetting.area.objectId]){
    //       this.billingSettingAreas.push(billingSetting.area)
    //       this.hashBillingSettings[billingSetting.area.objectId] = []
    //     }
    //     this.hashBillingSettings[billingSetting.area.objectId].push(billingSetting)
    //   }
    // }

    if (this.templateObjectData) {
      let contented = [];
      let data = this.templateObjectData || {};
      for (let html of this.content) {
        if (data["cusProfileImg"]) html = html.replaceAll("/images/myket-example-profile.png", data["cusProfileImg"])
        if (data["cusCitizenCardImg"]) html = html.replaceAll("/images/myket-example-citizen-card.png", data["cusCitizenCardImg"])
        let chunks = html.split(/({{[A-Za-z0-9_.]+}})/g);
        let chunksTranslated = chunks.map(function (chunk) {
          if (
            chunk.slice(0, 2) === "{{" &&
            chunk.slice(-2) === "}}" &&
            (data[chunk.slice(2, -2)] || data[chunk.slice(2, -2)] == 0)
          ) {
            let key = chunk.slice(2, -2);
            return data[key];
          }
          return chunk;
        });
        contented.push(chunksTranslated.join(""));
      }
      this.content = contented;
    }

    let tempContent = JSON.parse(JSON.stringify(this.content));
    this.content = [];
    this.updateImageSize(tempContent);

    if (this.type == "template") {
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
      if (this.accountingProducts) {
        for (let accountingProduct of this.accountingProducts) {
          this.dataTable.data.push({
            name: `${accountingProduct.name} (${this.$t('month')})`,
            value: `rm_${accountingProduct.objectId}`
          });
          this.dataTable.data.push({
            name: `${accountingProduct.name} (${this.$t('sum')})`,
            value: `ra_${accountingProduct.objectId}`
          });
          this.dataTable.data.push({
            name: `${accountingProduct.name} (${this.$t('month_text')})`,
            value: `rmt_${accountingProduct.objectId}`
          });
          this.dataTable.data.push({
            name: `${accountingProduct.name} (${this.$t('sum_text')})`,
            value: `rat_${accountingProduct.objectId}`
          });

          this.billInputData.push({
            name: `${accountingProduct.name} (${this.$t('month')})`,
            value: `rm_${accountingProduct.objectId}`
          });
          this.billInputData.push({
            name: `${accountingProduct.name} (${this.$t('sum')})`,
            value: `ra_${accountingProduct.objectId}`
          });
          this.billInputData.push({
            name: `${accountingProduct.name} (${this.$t('month_text')})`,
            value: `rmt_${accountingProduct.objectId}`
          });
          this.billInputData.push({
            name: `${accountingProduct.name} (${this.$t('sum_text')})`,
            value: `rat_${accountingProduct.objectId}`
          });
        }
      }
    }
    this.customerInputData = this.customerInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.contractInputData = this.contractInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.billInputData = this.billInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.contractSuspendInputData = this.contractSuspendInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.areaInterestInputData = this.areaInterestInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.dataTable.data = []
    for (let data of [
      ...this.customerInputData,
      ...this.contractInputData,
      ...this.billInputData,
      ...this.contractSuspendInputData,
      ...this.areaInterestInputData
    ]) {
      if (!this.dataTable.data.find(d => d.value == data.value)) {
        this.dataTable.data.push(data)
      }
    }
    // Initialize gesture flags
    let start_zoom_gesture = false;
    let start_dist_touch = false;
    let start_zoom_touch = false;

    // Manage ctrl+scroll zoom (or trackpad pinch)
    window.addEventListener(
      "wheel",
      e => {
        if (e.ctrlKey) {
          e.preventDefault();
          this.zoom = Math.min(
            Math.max(this.zoom - e.deltaY * 0.01, this.zoom_min),
            this.zoom_max
          );
        }
      },
      { passive: false }
    );

    // Manage trackpad pinch on Safari
    window.addEventListener("gesturestart", e => {
      e.preventDefault();
      start_zoom_gesture = this.zoom;
    });
    window.addEventListener("gesturechange", e => {
      e.preventDefault();
      if (!start_zoom_touch) {
        this.zoom = Math.min(
          Math.max(start_zoom_gesture * e.scale, this.zoom_min),
          this.zoom_max
        );
      }
    });
    window.addEventListener("gestureend", () => {
      start_zoom_gesture = false;
    });

    // Manage pinch to zoom for touch devices
    window.addEventListener(
      "touchstart",
      e => {
        if (e.touches.length == 2) {
          e.preventDefault();
          start_dist_touch = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          );
          start_zoom_touch = this.zoom;
        }
      },
      { passive: false }
    );
    window.addEventListener(
      "touchmove",
      e => {
        if (start_dist_touch && start_zoom_touch) {
          e.preventDefault();
          let zoom =
            (start_zoom_touch *
              Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
              )) /
            start_dist_touch;
          this.zoom = Math.min(Math.max(zoom, this.zoom_min), this.zoom_max);
        }
      },
      { passive: false }
    );
    window.addEventListener(
      "touchend",
      () => {
        start_dist_touch = false;
        start_zoom_touch = false;
      },
      { passive: false }
    );

    // Manage history undo/redo events
    const manage_undo_redo = e => {
      switch (e && e.inputType) {
        case "historyUndo":
          e.preventDefault();
          e.stopPropagation();
          this.undo();
          break;
        case "historyRedo":
          e.preventDefault();
          e.stopPropagation();
          this.redo();
          break;
      }
    };
    window.addEventListener("beforeinput", manage_undo_redo);
    window.addEventListener("input", manage_undo_redo); // in case of beforeinput event is not implemented (Firefox)
  },

  mounted() {
    setTimeout(() => {
      this.isTimeOuted = true;
    }, 200);
    setTimeout(() => {
      this.mounted = true;
      // init Event
      let editor = document.getElementById("editor");
      editor.addEventListener("paste", function (e) {
        e.preventDefault();
        var text = (e.originalEvent || e).clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
      });
    }, 500);
  },

  computed: {
    ...mapState({
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    fontSizeList() {
      return [
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        30,
        32,
        34,
        36,
        38,
        40,
        42,
        44,
        46,
        48
      ].map(d => {
        return {
          text: d,
          value: d + "px"
        };
      });
    },
    menu1() {
      let menu = [];
      // { text: "แปลงเลข", title: "Add", icon: "transform", click: () => { this.dialogConvertNumber() } },
      if (this.type != "preview") {
        menu.push({
          text: this.$t('save'),
          title: "Save",
          icon: "save",
          click: () => {
            this.title
              ? this.onDialogSaveNewAgree()
              : (this.isDialogSaveNew = true);
          }
        });
      }
      menu.push({
        text: this.$t('print'),
        title: "Print",
        icon: "print",
        click: () => {
          window.print();
          // this.onAddExampleImage()
        }
      });
      if (this.type == "template") {
        menu.push({
          text: this.$t('input_data_placeholder'),
          title: "Add",
          icon: "note_add",
          disabled: !this.current_text_style,
          click: () => {
            this.dialogAddText();
          }
        });
      }
      // if(this.billingSettings && this.billingSettings.length){
      //   menu = [...menu,
      //     { text: "ข้อมูลการตั้งค่า", title: "Add", icon: "manage_accounts", click: () => { this.isDialogContractData = true } },
      //   ]
      // }

      menu = [
        ...menu,
        {
          text: this.$t('add_picture'),
          title: "Add",
          icon: "note_add",
          disabled: !this.current_text_style,
          click: () => {
            this.dialogUploadImage();
          }
        },
        { is: "spacer" },
        {
          text: this.$t('close'),
          title: "cancel",
          icon: "cancel",
          click: () => {
            this.isCloseDialog = true;
          }
        },
        { disabled: true }
      ];
      return menu;
    },
    menu2() {
      return [
        // Undo / redo commands
        {
          title: "Undo",
          icon: "undo",
          disabled: !this.can_undo,
          hotkey: this.isMacLike ? "command+z" : "ctrl+z",
          click: () => this.undo()
        },
        {
          title: "Redo",
          icon: "redo",
          disabled: !this.can_redo,
          hotkey: this.isMacLike ? "shift+command+z" : "ctrl+y",
          click: () => this.redo()
        },

        { is: "spacer" },

        // Rich text menus
        {
          icon: "format_align_left",
          title: "Align left",
          active: this.isLeftAligned,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "shift+command+l" : "ctrl+shift+l",
          click: () => {
            document.execCommand("justifyLeft")
            var el = window.getSelection().focusNode;
            if (el) {
              el.classList.add("img-left")
              el.classList.remove("img-center")
              el.classList.remove("img-right")
            }
          }
        },
        {
          icon: "format_align_center",
          title: "Align center",
          active: this.isCentered,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "shift+command+e" : "ctrl+shift+e",
          click: () => {
            document.execCommand("justifyCenter")
            var el = window.getSelection().focusNode;
            if (el) {
              el.classList.add("img-center")
              el.classList.remove("img-left")
              el.classList.remove("img-right")
            }
          }
        },
        {
          icon: "format_align_right",
          title: "Align right",
          active: this.isRightAligned,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "shift+command+r" : "ctrl+shift+r",
          click: () => {
            document.execCommand("justifyRight")
            var el = window.getSelection().focusNode;
            if (el) {
              el.classList.add("img-right")
              el.classList.remove("img-left")
              el.classList.remove("img-center")
            }
          }
        },
        {
          icon: "format_align_justify",
          title: "Justify content",
          active: this.isJustified,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "shift+command+j" : "ctrl+shift+j",
          click: () => document.execCommand("justifyFull")
        },
        { is: "separator" },
        {
          icon: "format_bold",
          title: "Bold",
          active: this.isBold,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "command+b" : "ctrl+b",
          click: () => document.execCommand("bold")
        },
        {
          icon: "format_italic",
          title: "Italic",
          active: this.isItalic,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "command+i" : "ctrl+i",
          click: () => document.execCommand("italic")
        },
        {
          icon: "format_underline",
          title: "Underline",
          active: this.isUnderline,
          disabled: !this.current_text_style,
          hotkey: this.isMacLike ? "command+u" : "ctrl+u",
          click: () => document.execCommand("underline")
        },
        {
          icon: "format_strikethrough",
          title: "Strike through",
          active: this.isStrikeThrough,
          disabled: !this.current_text_style,
          click: () => document.execCommand("strikethrough")
        },
        {
          is: "button-color",
          type: "compact",
          menu_class: "align-center",
          disabled: !this.current_text_style,
          color: this.curColor,
          update_color: new_color =>
            document.execCommand("foreColor", false, new_color.hex8)
        },
        { is: "separator" },
        {
          icon: "format_list_numbered",
          title: "Numbered list",
          active: this.isNumberedList,
          disabled: !this.current_text_style,
          click: () => document.execCommand("insertOrderedList")
        },
        {
          icon: "format_list_bulleted",
          title: "Bulleted list",
          active: this.isBulletedList,
          disabled: !this.current_text_style,
          click: () => document.execCommand("insertUnorderedList")
        },
        { is: "separator" },
        {
          icon: "format_indent_increase",
          title: "Increase indent",
          hotkey: "tab",
          disabled: !this.current_text_style,
          click: () => {
            document.execCommand("insertText", false, `                `);
          }
        },
        { is: "separator" },
        {
          icon: "text_fields",
          title: "Font Size",
          active: this.isBulletedList,
          disabled: !this.current_text_style,
          click: () => (this.isPaperSettingDialog = true)
        },
        {
          html: "<b>H1</b>",
          title: "Header 1",
          // active: this.isH1,
          disabled: !this.current_text_style,
          click: () => document.execCommand("fontSize", false, 7)
        },
        {
          html: "<b>H2</b>",
          title: "Header 2",
          // active: this.isH2,
          disabled: !this.current_text_style,
          click: () => document.execCommand("fontSize", false, 6)
        },
        {
          html: "<b>H3</b>",
          title: "Header 3",
          // active: this.isH3,
          disabled: !this.current_text_style,
          click: () => document.execCommand("fontSize", false, 5)
        },
        {
          icon: "format_clear",
          title: "Clear format",
          disabled: !this.current_text_style,
          click() {
            document.execCommand("removeFormat");
            document.execCommand("formatBlock", false, "<div>");
          }
        },
        {
          icon: "calendar_view_month",
          title: "Clear format",
          disabled: !this.current_text_style,
          click: () => {
            this.addTableDialog();
          }
        },
        // { icon: "splitscreen", title: "Page break", disabled: !this.current_text_style, click: () => this.insertPageBreak() },

        { is: "spacer" },

        {
          // Format menu
          text: this.current_format_name,
          title: "Format",
          icon: "crop_free",
          chevron: true,
          menu: this.formats.map(([text, w, h]) => {
            return {
              text,
              active: this.pageFormat[0] == w && this.pageFormat[1] == h,
              click: () => {
                let tempContent = JSON.parse(JSON.stringify(this.content));
                this.content = [];
                this.pageFormat = [w, h];
                this.updateImageSize(tempContent);
              }
            };
          }),
          menu_width: 80,
          menu_height: 280
        },
        {
          // Margins menu
          text: this.current_margins_name,
          title: "Margins",
          icon: "select_all",
          chevron: true,
          menu: this.margins.map(([text, value]) => {
            return {
              text: text + " (" + value + ")",
              active: this.pageMargins == value,
              click: () => {
                let tempContent = JSON.parse(JSON.stringify(this.content));
                this.content = [];
                this.pageMargins = value;
                this.updateImageSize(tempContent);
              }
            };
          }),
          menu_width: 200,
          menu_class: "align-center"
        },
        {
          // Zoom menu
          text: Math.floor(this.zoom * 100) + "%",
          title: "Zoom",
          icon: "zoom_in",
          chevron: true,
          menu: [
            ["200%", 2.0],
            ["150%", 1.5],
            ["125%", 1.25],
            ["100%", 1.0],
            ["75%", 0.75],
            ["50%", 0.5],
            ["25%", 0.25]
          ].map(([text, zoom]) => {
            return {
              text,
              active: this.zoom == zoom,
              click: () => {
                this.zoom = zoom;
              }
            };
          }),
          menu_width: 80,
          menu_height: 280,
          menu_class: "align-center"
        },
        {
          // Display mode menu
          title: "Display",
          icon:
            this.display == "horizontal"
              ? "view_column"
              : this.display == "vertical"
                ? "view_stream"
                : "view_module",
          chevron: true,
          menu: [
            {
              icon: "view_module",
              active: this.display == "grid",
              click: () => {
                this.display = "grid";
              }
            },
            // {
            //   icon: "view_column",
            //   active: this.display == "horizontal",
            //   click: () => {
            //     this.display = "horizontal";
            //   }
            // },
            {
              icon: "view_stream",
              active: this.display == "vertical",
              click: () => {
                this.display = "vertical";
              }
            }
          ],
          menu_width: 55,
          menu_class: "align-right"
        }
      ];
    },

    // Formats management
    current_format_name() {
      const format = this.formats.find(
        ([, width_mm, height_mm]) =>
          this.pageFormat[0] == width_mm && this.pageFormat[1] == height_mm
      );
      return format
        ? format[0]
        : this.pageFormat[0] + "mm x " + this.pageFormat[1] + "mm";
    },
    formats: () => [
      ["A0", 841, 1189],
      ["A0L", 1189, 841],
      ["A1", 594, 841],
      ["A1L", 841, 594],
      ["A2", 420, 594],
      ["A2L", 594, 420],
      ["A3", 297, 420],
      ["A3L", 420, 297],
      ["A4", 210, 297],
      ["A4L", 297, 210],
      ["A5", 148, 210],
      ["A5L", 210, 148],
      ["A6", 105, 148],
      ["A6L", 148, 105]
    ],

    // Margins management
    current_margins_name() {
      const margins = this.margins.find(
        ([, margins]) => this.pageMargins == margins
      );
      return margins ? margins[0] : margins[1];
    },
    margins: () => [
      ["Medium", "20mm"],
      ["Small", "15mm"],
      ["Slim", "10mm 15mm"],
      ["Tiny", "5mm"]
    ],

    // Current text style management
    current_text_style() {
      return this.mounted ? this.$refs.editor.current_text_style : false;
    },
    isLeftAligned() {
      return ["start", "left", "-moz-left"].includes(
        this.current_text_style.textAlign
      );
    },
    isRightAligned() {
      return ["end", "right", "-moz-right"].includes(
        this.current_text_style.textAlign
      );
    },
    isCentered() {
      return ["center", "-moz-center"].includes(
        this.current_text_style.textAlign
      );
    },
    isJustified() {
      return ["justify", "justify-all"].includes(
        this.current_text_style.textAlign
      );
    },
    isBold() {
      const fontWeight = this.current_text_style.fontWeight;
      return (
        fontWeight &&
        (parseInt(fontWeight) > 400 || fontWeight.indexOf("bold") == 0)
      );
    },
    isItalic() {
      return this.current_text_style.fontStyle == "italic";
    },
    isUnderline() {
      // text-decoration is not overridden by children, so we query the parent stack
      const stack = this.current_text_style.textDecorationStack;
      return stack && stack.some(d => d.indexOf("underline") == 0);
    },
    isStrikeThrough() {
      // text-decoration is not overridden by children, so we query the parent stack
      const stack = this.current_text_style.textDecorationStack;
      return stack && stack.some(d => d.indexOf("line-through") == 0);
    },
    isNumberedList() {
      return (
        this.current_text_style.isList &&
        this.current_text_style.listStyleType == "decimal"
      );
    },
    isBulletedList() {
      return (
        this.current_text_style.isList &&
        ["disc", "circle"].includes(this.current_text_style.listStyleType)
      );
    },
    isH1() {
      return this.current_text_style.headerLevel == 1;
    },
    isH2() {
      return this.current_text_style.headerLevel == 2;
    },
    isH3() {
      return this.current_text_style.headerLevel == 3;
    },
    curColor() {
      return this.current_text_style.color || "transparent";
    },

    // Platform management
    isMacLike: () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),

    // Undo / redo flags
    can_undo() {
      return this.undo_count > 0;
    },
    can_redo() {
      return this.content_history.length - this.undo_count - 1 > 0;
    }
  },

  methods: {
    // Undo / redo functions examples
    undo() {
      if (this.can_undo) {
        this._mute_next_content_watcher = true;
        this.content = this.content_history[--this.undo_count];
      }
    },
    redo() {
      if (this.can_redo) {
        this._mute_next_content_watcher = true;
        this.content = this.content_history[++this.undo_count];
      }
    },
    resetContentHistory() {
      this.content_history = [];
      this.undo_count = -1;
    },

    // Insert page break function example
    async insertPageBreak() {
      // insert paragraph at caret position
      document.execCommand("insertParagraph");

      // insert a marker at caret position (start of the new paragraph)
      const marker = "###PB###"; // must be regex compatible
      document.execCommand("insertText", false, marker);

      // wait for v-model content update (two ticks are needed to reactivate watch on content)
      await this.$nextTick();
      await this.$nextTick();

      // find the marker inside content items and split this content item in two items between the two paragraphs
      // only match root tags (p, div, h1, h2...) to avoid non-root tags like <li>
      const regexp = new RegExp("<(p|div|h\\d)( [^/>]+)*>(<[^/>]+>)*" + marker);
      for (let i = 0; i < this.content.length; i++) {
        const item = this.content[i];
        if (typeof item != "string") continue;
        const match = regexp.exec(item);
        if (match) {
          const tags_open = match[0].slice(0, -marker.length);
          let content_plus_tags_close = item.substr(
            match.index + match[0].length
          );
          // insert <br> to empty pages that would not be handled correctly by contenteditable
          if (content_plus_tags_close.indexOf("</") == 0)
            content_plus_tags_close = "<br>" + content_plus_tags_close;
          this.content.splice(
            i,
            1,
            item.substr(0, match.index),
            tags_open + content_plus_tags_close
          );
          return;
        }
      }

      // if the code didn't return before, the split didn't work (e.g. inside a <li>). just remove the marker from the content
      for (let i = 0; i < this.content.length; i++) {
        const item = this.content[i];
        if (typeof item != "string" || item.indexOf(marker) < 0) continue;
        this.content.splice(i, 1, item.replace(marker, ""));
        break;
      }
    },
    onDialogSaveNewAgree() {
      if (!this.title) {
        if (this.$refs.form.validate()) {
          this.$emit("onSave", {
            layout: this.content,
            title: this.tempTitle,
            paperSetting: {
              pageFormat: this.pageFormat,
              pageMargins: this.pageMargins,
              pageFontSize: this.pageFontSize
            }
          });
          this.$emit("onClose", true);
        }
      } else {
        this.$emit("onSave", {
          layout: this.content,
          title: this.tempTitle,
          paperSetting: {
            pageFormat: this.pageFormat,
            pageMargins: this.pageMargins,
            pageFontSize: this.pageFontSize
          }
        });
        this.$emit("onClose", true);
      }
    },
    dialogAddText() {
      this.saveRange();
      this.searchData = "";
      this.isDialogAddData = true;
    },
    addText(data) {
      if (this.tempRange) {
        if (data.value == "{{cusProfileImg}}" || data.value == "{{cusCitizenCardImg}}") {
          this.onAddExampleImage(data.value)
          this.isDialogAddData = false;
        } else {
          this.initRange();
          document.execCommand("insertText", false, data.value);
          this.isDialogAddData = false;
        }
      }
    },
    print() {
      setTimeout(() => {
        window.print();
      }, 200);
    },
    dialogConvertNumber() {
      this.isDialogConvertNumber = true;
      setTimeout(() => {
        this.$refs.convertNumber.focus();
      }, 200);
    },
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.convertNumber = null;
      this.isDialogConvertNumber = false;
      this.isDialogContractData = false;
      this.isCopySuccess = true;
    },
    pricePerType(billingSetting, formatType) {
      if (billingSetting.type == "quantity") {
        if (formatType == "currency") return "/" + this.$t('unit');
        else return `${this.$helper.currencyThEn()}/${this.$t('unit')}`;
      } else if (billingSetting.type == "monthly") {
        if (formatType == "currency") return "/" + this.$t('month');
        else return `${this.$helper.currencyThEn()}/${this.$t('month')}`;
      } else {
        return "";
      }
    },
    saveRange() {
      if (window.getSelection) {
        var sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          this.tempRange = sel.getRangeAt(0);
        }
      } else if (document.selection && document.selection.createRange) {
        this.tempRange = document.selection.createRange();
      }
    },
    initRange() {
      if (this.tempRange) {
        if (window.getSelection) {
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(this.tempRange);
        } else if (document.selection && this.tempRange.select) {
          this.tempRange.select();
        }
      }
    },
    dialogUploadImage() {
      this.saveRange();
      this.isUploadImageDialog = true;
    },
    onUploadImageSuccess(file) {
      if (this.tempRange) {
        const _this = this;
        this.initRange();
        let image = new Image();

        image.src = file.url;
        image.onload = async function () {
          let pageSize = await _this.getPageSize();
          if (pageSize) {
            let overflowHeight = this.height - pageSize.height;
            let overflowWidth = this.width - pageSize.width;
            let html = `<img src="${file.url}" style="height: ${this.height}px; width: auto">`;
            if (overflowHeight > 0 || overflowWidth > 0) {
              if (overflowHeight >= overflowWidth) {
                html = `<img src="${file.url}" style="height: ${pageSize.height}px; width: auto">`;
              } else {
                html = `<img src="${file.url}" style="height: auto; width: ${pageSize.widt}px">`;
              }
            }
            document.execCommand("insertHTML", false, html);
            return true;
          }
        };
      }
    },
    addTableDialog() {
      this.formTable = {
        width: 100,
        col: null,
        row: null,
        position: "center"
      };
      this.saveRange();
      if (this.$refs.formTable) this.$refs.formTable.resetValidation();
      this.isAddTableDialog = true;
    },
    onAddTable() {
      if (this.$refs.formTable.validate()) {
        if (this.tempRange) {
          this.initRange();
          this.isAddTableDialog = false;
          let style = {
            start: "",
            center: "margin-left: auto;margin-right: auto;",
            end: "margin-left: auto;"
          };
          let html = `<div style='width:100%' class='box-editor-table'><table style='width:${this.formTable.width}%;${style[this.formTable.position]}'>`;
          for (let row = 1; row <= parseInt(this.formTable.row); row++) {
            html += `<tr>`;
            for (let col = 1; col <= parseInt(this.formTable.col); col++) {
              html += `<td>&nbsp;</td>`;
            }
            html += `</tr>`;
          }
          html += "</table></div>";
          document.execCommand("insertHTML", false, html);
        }
      }
    },
    getPageSize() {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        setTimeout(() => {
          if (document.getElementsByClassName("page")) {
            let pageElement = document.getElementsByClassName("page")[0];
            var computedStyle = getComputedStyle(pageElement);

            let elementHeight = pageElement.clientHeight; // height with padding
            let elementWidth = pageElement.clientWidth; // width with padding

            elementHeight -=
              parseFloat(computedStyle.paddingTop) +
              parseFloat(computedStyle.paddingBottom);
            elementWidth -=
              parseFloat(computedStyle.paddingLeft) +
              parseFloat(computedStyle.paddingRight);

            this.isLoading = false
            resolve({
              width: elementWidth,
              height: elementHeight
            });
          }
        }, 2000);
      });
    },
    async updateImageSize(tempContent) {
      let pageSize = await this.getPageSize();
      if (pageSize) {
        let contented = [];
        this.content = [];
        for (let html of tempContent) {
          let dom = document.getElementById("demo-templete")
          dom.innerHTML = html;
          let images = dom.getElementsByTagName("img");
          for (let image of images) {
            let size = image.getBoundingClientRect()
            let overflowHeight = size.height - pageSize.height;
            let overflowWidth = size.width - pageSize.width;
            if (overflowHeight > 0 || overflowWidth > 0) {
              image.style.removeProperty("min-height");
              image.style.removeProperty("min-width");
              let { width, height } = calculateAspectRatioFit(image.width, image.height, pageSize.width, pageSize.height)
              image.style.height = height + "px";
              image.style.width = width + "px";
            }
          }
          contented.push(dom.innerHTML);
          if (!this.content || (this.content && !this.content.find(d => d))) this.content = [dom.innerHTML];
          else this.content.push(dom.innerHTML);
          dom.innerHTML = ""
        }
      }
      function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return { width: Math.ceil(srcWidth * ratio), height: Math.ceil(srcHeight * ratio) };
      }
    },
    onAddExampleImage(value) {
      this.resetExampleForm()
      this.isAddExampleImage = true
      let width = 0
      let height = 0
      if (value == "{{cusProfileImg}}") {
        this.exampleImgSrc = "/images/myket-example-profile.png"
        width = 466
        height = 561
      } else if (value == "{{cusCitizenCardImg}}") {
        this.exampleImgSrc = "/images/myket-example-citizen-card.png"
        width = 740
        height = 467
      }
      this.imageWidth = width
      this.imageHeight = height

      this.tempImageWidth = width
      this.tempImageHeight = height

      this.sliderMaxWidth = width * 2
      this.sliderMaxHeight = height * 2
      if (!this.isLockAspect) this.onLockAspect()
    },
    onLockAspect() {
      this.isLockAspect = !this.isLockAspect
      if (this.isLockAspect) {
        this.tempImageHeight = JSON.parse(JSON.stringify(this.imageHeight))
        this.tempImageWidth = JSON.parse(JSON.stringify(this.imageWidth))
      }
    },
    onChageSize(type) {
      let ar = this.tempImageWidth / this.tempImageHeight
      if (this.isLockAspect) {
        if (type == "width") {
          this.imageHeight = Math.round(this.tempImageHeight + (this.imageWidth - this.tempImageWidth) / ar)
        } else {
          this.imageWidth = Math.round(this.tempImageWidth + (this.imageHeight - this.tempImageHeight) * ar)
        }
      }
    },
    uploadExampleImage() {
      if (this.tempRange) {
        this.initRange();
        this.isAddExampleImage = false;
        let html = `<img src="${this.exampleImgSrc}" style="height: ${this.isAutoImageHeight ? 'auto' : this.imageHeight + 'px'}; width: ${this.isAutoImageWidth ? 'auto' : this.imageWidth + 'px'}">`;
        document.execCommand("insertHTML", false, html);
      }
    },
    resetExampleForm() {
      this.imageWidth = 0
      this.imageHeight = 0
      this.imageWidth = 0
      this.tempImageWidth = 0
      this.tempImageHeight = 0
      this.sliderMaxWidth = 0
      this.sliderMaxHeight = 0
      this.isLockAspect = false
      this.isAutoImageWidth = false
      this.isAutoImageHeight = false
    },
  },
  watch: {
    content: {
      immediate: true,
      // Fill undo / redo history stack on user input
      handler(new_content) {
        if (!this._mute_next_content_watcher) {
          // only update the stack when content is changed by user input, not undo/redo commands
          this.content_history[++this.undo_count] = new_content;
          this.content_history.length = this.undo_count + 1; // remove all redo items
        }
        this._mute_next_content_watcher = false;
      }
    },
    pageFontSize(value) {
      let temp = JSON.parse(JSON.stringify(this.content));
      this.content = [];
      let root = document.documentElement;
      root.style.setProperty("--font-size", value);
      setTimeout(() => {
        this.content = temp;
      }, 100);
    }
  }
};
</script>
<style scoped>
.card-add-image {
  background-color: rgba(255, 255, 255, 0.6);
}

.link-variant {
  position: absolute;
  display: inline;
  top: 33px;
  right: -180px;
}

.auto-width {
  position: absolute;
  display: inline;
  top: 8px;
  right: -140px;
}

.auto-height {
  position: absolute;
  display: inline;
  top: 8px;
  right: -145px;
}
</style>
<style lang="scss">
:root {
  --font-size: 16px;
}

ul,
ol {
  list-style: disc outside none;
}

ol {
  list-style-type: decimal;
}

li {
  display: list-item;
}

.main {
  width: fit-content;
  min-width: 100%;
  position: absolute;
  top: 0;
  background-color: rgb(245, 245, 245);
  /* transition: all .5s; */
  left: 0;
  color: black !important;
  min-height: 100% !important;
}

.bar {
  position: sticky;
  left: 0;
  top: 0;
  width: calc(100vw - 16px);
  z-index: 1000;
  background: rgba(248, 249, 250, 0.8);
  border-bottom: solid 1px rgb(248, 249, 250);
  backdrop-filter: blur(10px);
  --bar-button-active-color: #188038;
  --bar-button-open-color: #188038;
  --bar-button-active-bkg: #e6f4ea;
  --bar-button-open-bkg: #e6f4ea;
}

.editor {
  font-weight: normal;
  // font-size: 16px;
  line-height: 1.5 !important;

  table,
  th,
  td {
    border: 1px solid black;
  }
}

.editor>.content>.page * {
  font-family: "Sarabun" !important;
  letter-spacing: 0px !important;
}

// .editor > .content > .page > img * {
//   height: 200px !important;
// }
.font-size {
  * {
    font-size: var(--font-size) !important;
  }
}

font[size='7'] {
  font-size: calc(var(--font-size) * 1.8) !important;

  * {
    font-size: calc(var(--font-size) * 1.8) !important;
  }
}

font[size='6'] {
  font-size: calc(var(--font-size) * 1.5) !important;

  * {
    font-size: calc(var(--font-size) * 1.5) !important;
  }
}

font[size='5'] {
  font-size: calc(var(--font-size) * 1.3) !important;

  * {
    font-size: calc(var(--font-size) * 1.3) !important;
  }
}

.img-center img {
  margin-left: auto;
  margin-right: auto;
}

.img-left img {
  margin-left: 0;
  margin-right: auto;
}

.img-right img {
  margin-left: auto;
  margin-right: 0;
}

@media print {
  * {
    font-family: "Sarabun" !important;
    font-size: var(--font-size) !important;
  }

  h1 {
    font-size: calc(var(--font-size) * 1.8) !important;
  }

  h2 {
    font-size: calc(var(--font-size) * 1.5) !important;
  }

  h3 {
    font-size: calc(var(--font-size) * 1.3) !important;
  }

  .editor>.content>.page {
    display: inline-block !important;
    overflow: hidden !important;
  }

  .box-editor-table {

    table,
    th,
    td {
      border: 1px solid black;
      padding: 0;
      margin: 0;
    }
  }
}
</style>